import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import RevenueReport from "./tabs/report";
import RevenueBusinesses from "./tabs/businesses";
import RevenueShippers from "./tabs/shippers";
import RevenueSettings from "./tabs/revenueSettings";

// Heading and left navigation come from RevenueLayout
export default function Revenue() {
  const DEFAULT_ACTIVE_TAB = "reports";
  const navigate = useNavigate();
  const { active_tab } = useParams();

  useEffect(() => {
    if (!active_tab) {
      navigate(`/admin/revenue/${DEFAULT_ACTIVE_TAB}`, { replace: true });
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div data-test="revenue-page">
      {active_tab === "reports" && <RevenueReport />}
      {active_tab === "businesses" && <RevenueBusinesses />}
      {active_tab === "shippers" && <RevenueShippers />}
      {active_tab === "revenue-settings" && <RevenueSettings />}
    </div>
  );
}
